import { render, staticRenderFns } from "./Ultrasound.vue?vue&type=template&id=031116e3&scoped=true&"
import script from "./Ultrasound.vue?vue&type=script&lang=js&"
export * from "./Ultrasound.vue?vue&type=script&lang=js&"
import style0 from "./Ultrasound.vue?vue&type=style&index=0&id=031116e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031116e3",
  null
  
)

export default component.exports